import { NzModalService } from 'ng-zorro-antd/modal';
import { AlertComponent } from '../alert/alert.component';
import { NzModalServiceComponent } from './nz-modal-service.component';
import { ApplicationRef, ComponentFactoryResolver, Injectable, ViewContainerRef } from '@angular/core';
import { HIDE_ANT_MODAL_CLASS, MONIEPOINT_DESIGN_TYPE } from '../../../shared/constants';
import { KamonaDialogAlertComponent } from '../kamona-components/kamona-dialog-alert/kamona-dialog-alert.component';
import { DialogMessageType } from '../../../shared/models/utility.model';
import { PlainResultModalComponent } from '../../../shared/components/plain-result-modal/plain-result-modal.component';
import { KamonaProgressModalComponent } from '../../../kamona/components/kamona-progress-modal/kamona-progress-modal.component';

@Injectable({
    providedIn: 'root',
})
export class ModalService {
    modalComponentRef: NzModalServiceComponent;
    baseViewRef: ViewContainerRef;

    constructor(private componentFactoryResolver: ComponentFactoryResolver, public appRef: ApplicationRef, private modal: NzModalService) {
        // @ts-ignore
        this.baseViewRef = (appRef.components[0]?.instance as ViewContainerRef)?.viewRef;
        const modalComponentFactory = this.componentFactoryResolver.resolveComponentFactory(NzModalServiceComponent);
        this.modalComponentRef = this.baseViewRef?.createComponent(modalComponentFactory)?.instance;
    }

    public createModal<T>(component, modalOptions?: ModalOptionsConfig) {
        this.createModalFactory<T>();
        return this.modalComponentRef.createComponentModal(component, modalOptions);
    }

    public alert<T>(modalOptions?: ModalOptionsConfig) {
        this.createModalFactory<T>();
        modalOptions.nzWidth = modalOptions.nzWidth ? modalOptions.nzWidth : 329;
        return this.modalComponentRef.createComponentModal(AlertComponent, modalOptions);
    }

    public newalert<T>(modalOptions?: ModalOptionsConfig) {
        this.createModalFactory<T>();
        modalOptions.nzWidth = modalOptions.nzWidth ? modalOptions.nzWidth : 329;
        modalOptions.nzAutofocus = modalOptions.nzAutofocus ? modalOptions.nzAutofocus : null;
        return this.modalComponentRef.createComponentModal(KamonaDialogAlertComponent, modalOptions);
    }

    openInProgressModal(description = 'Loading...') {
        const config = new ModalOptionsConfig();
        config.nzMaskClosable = false;
        config.nzComponentParams.data = { description };
        config.className = HIDE_ANT_MODAL_CLASS;
        return this.createModal(KamonaProgressModalComponent, config);
    }

	launchResultModal(
		options: ResultModalConfig
	) {
        const config = new ModalOptionsConfig();
        config.nzClosable = false;
        config.nzMaskClosable = false;
        config.nzCentered = false;
        config.nzComponentParams.data = {
            isMobile: options?.isMobile === undefined ? false : options.isMobile,
            messageType: options.messageType,
            modalBody: options?.modalBody ? options?.modalBody : '',
            modalTitle: options.modalTitle,
			btnText: options?.btnText ? options?.btnText : ''
        };
        config.nzComponentParams.callback = options?.callback ? options?.callback : () =>{
			this.closeAll();
		};
        return this.createModal(PlainResultModalComponent, config);
    }

    public closeAll() {
        this.modal.closeAll();
    }

    private createModalFactory<T>() {
        const modalComponentFactory = this.componentFactoryResolver.resolveComponentFactory(NzModalServiceComponent);
        this.modalComponentRef = this.baseViewRef.createComponent(modalComponentFactory).instance;
    }

    showSuccess(title: string, msg?, callbackName?: string, callbackFn?:()=> void) {
        const config = new ModalOptionsConfig();
        config.nzComponentParams.alertType = 'success';
        config.nzComponentParams.title = title;
        config.nzComponentParams.message = msg || '';
        config.className = 'moniepoint-dialog';
        config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
        config.nzComponentParams.callbackName = callbackName ?? 'Dismiss';
        config.nzComponentParams.callback = callbackFn 
        this.newalert(config);
    }

    showError(title: string, msg?, callbackName?: string, callbackFn?:()=> void) {
        const config = new ModalOptionsConfig();
        config.nzComponentParams.alertType = 'error';
        config.nzComponentParams.title = title;
        config.nzComponentParams.message = msg || '';
        config.className = 'moniepoint-dialog';
        config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
        config.nzComponentParams.callbackName = callbackName ?? 'Dismiss';
        config.nzComponentParams.callback = callbackFn
        this.newalert(config);
    }
}

export interface ResultModalConfig{
	messageType: DialogMessageType;
	modalTitle: string;
	modalBody?: string;
	isMobile?: boolean;
	callback?: (res: any) => void;
	btnText?: string;
}

export class ModalOptionsConfig {
    nzTitle?: string;
    // tslint:disable-next-line:max-line-length
    nzComponentParams: {
        message;
        message2;
        message3;
        messageTemplate;
        title;
        data;
        callback;
        callbackName;
        declineText;
        alertType?: 'success' | 'confirm' | 'new_confirm' | 'error' | 'warning' | 'info' | any;
        designType?: MONIEPOINT_DESIGN_TYPE;
        cancelName;
        cancelCallback;
        expiryTime;
        ref;
        canShowLoading;
        expiryTimeText;
        extraMessage;
        cancelText;
        isDecline;
        showInfoModalAcceptButton?;
    };
    nzFooter: any;
    nzClosable?: boolean;
    nzMask?: boolean;
    nzMaskClosable?: boolean;
    nzWidth?: number;
    alertType?: 'success' | 'confirm' | 'error' | 'info';
    style: any;
    className: string;
    hideNZTitle?: boolean;
    nzCentered?: boolean;
    nzKeyboard?: boolean;
    nzAutofocus?: 'ok' | 'cancel' | 'auto' | null;

    constructor(obj?) {
        this.nzTitle = (obj && obj.nzTitle) || `<img src='/assets/images/moniepoint-logo.svg'>`;
        this.nzComponentParams = (obj && obj.nzComponentParams) || {};
        this.nzClosable = obj && obj.nzClosable;
        this.nzMaskClosable = obj && obj.nzMaskClosable;
        this.nzMask = obj && obj.nzMask;
        this.nzWidth = (obj && obj.nzWidth) || 496;
        this.style = (obj && obj.style) || {};
        this.className = (obj && obj.class) || '';
        this.alertType = obj && obj.alertType;
        this.hideNZTitle = obj && obj.hideNZTitle;
        this.nzCentered = (obj && obj.nzCentered) || false;
        this.nzKeyboard = (obj && obj.nzKeyboard) || false;
        this.nzAutofocus = 'auto';
    }
}
